import { http } from '@/api/http.js'

function okCode(res) {
  return res && (res.code === 200 || res.code === 0 || res.code === '200')
}

export function listTrackConfig(params) {
  return http.$get('/track/config/listPage', params).then(res => {
    if (!okCode(res)) {
      return Promise.reject(res)
    }
    return res
  })
}

export function listTrackModules() {
  return http.$get('/track/config/modules').then(res => {
    if (!okCode(res)) {
      return Promise.reject(res)
    }
    return res
  })
}

export function getTrackConfig(id) {
  return http.$get('/track/config/detail', { id: id }).then(res => {
    if (!okCode(res)) {
      return Promise.reject(res)
    }
    return res
  })
}

export function addTrackConfig(data) {
  return http.$post('/track/config/add', data, true)
}

export function updateTrackConfig(data) {
  return http.$post('/track/config/update', data, true)
}

export function removeTrackConfig(ids) {
  return http.$post('/track/config/remove', ids, true)
}

/** 登录用户可读的采集路由，不需要埋点配置权限 */
export function listTrackRoutes() {
  return http.$get('/track/routes').then(res => {
    if (!okCode(res)) {
      return Promise.reject(res)
    }
    return res
  })
}



// WEBPACK FOOTER //
// ./src/api/trackConfig.js